var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "JadeDrawer",
        {
          attrs: { open: _vm.selfOpen, title: _vm.$t("title") },
          on: {
            "update:open": function ($event) {
              _vm.selfOpen = $event
            },
            toggle: _vm.handleToggle,
          },
        },
        [
          _c(
            "JadeBox",
            [
              _c("DataInfosContainer", { attrs: { data: _vm.computedInfos } }),
              _vm.computedAntifraud
                ? _c("DataAntifraudContainer", {
                    attrs: { data: _vm.computedAntifraud },
                  })
                : _vm._e(),
              _vm.computedAcquirer
                ? _c("DataAcquirerContainer", {
                    attrs: { data: _vm.computedAcquirer },
                    on: { handleCopied: _vm.handleToast },
                  })
                : _vm._e(),
              _vm.computedOthers.hasOthers
                ? _c("DataOthersContainer", {
                    attrs: { data: _vm.computedOthers },
                  })
                : _vm._e(),
              _c(
                "JadeBox",
                { attrs: { "has-padding": "" } },
                [_vm._t("log")],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("JadeToastHub", { ref: "toast" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }